/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ImageExample .ms-Image{border:1px solid "},{"theme":"neutralLight","defaultValue":"#eaeaea"},{"rawString":"}"}]);
/* tslint:enable */
